
























import GlobalHeader from './GlobalHeader.vue'
import GlobalFooter from './GlobalFooter.vue'
import Drawer from '@/components/tool/Drawer.vue'
import SiderMenu from '@/components/menu/SiderMenu.vue'
import { getUser, getCurrentPerms, logout, getUserSettings, updateUserSettings } from '@/store'
import Setting from '@/components/setting/Setting.vue'
import { clean } from '@/fn/object.ts'
const minHeight = window.innerHeight - 64 - 24 - 122

const formatroute = (router: any) => {
  router = router.filter((it: any) => !(it.meta.show && it.meta.show)).map((its: any) => {
    const item = its.children && its.children.length > 0 ? formatroute(its.children) : ''
    return its.children ? clean({
        name: its.name,
        ...its,
        icon: its.meta.icon,
        children: item.length > 0 ? item : ''
      }) : clean({
      ...its,
      name: its.name,
      icon: its.meta.icon,
      children: ''
    })
  })
  return router
}
const menuData: any = []
import ViewBase from '@/utils/ViewBase'
import { Component, Prop, Watch } from 'vue-property-decorator'

@Component({
  components: {
    Setting,
    SiderMenu,
    Drawer,
    GlobalFooter,
    GlobalHeader
  }
})
export default class Main extends ViewBase {

  minHeight = minHeight + 'px'
  collapsed = false
  menuData = menuData
  showSetting =  false

  get isMobile() {
    return this.$store.state.setting.isMobile
  }
  get theme() {
    return this.$store.state.setting.theme
  }
  get layout() {
    return this.$store.state.setting.layout
  }
  get linkList() {
    return this.$store.state.setting.footerLinks
  }
  get copyright() {
    return this.$store.state.setting.copyright
  }

  get en() {
    return this.$store.state.setting.en
  }

  created() {
    this.init()
  }

  async init() {
    const perms = await getCurrentPerms(this.en)
    this.menuData = perms.menu
  }

  toggleCollapse() {
    this.collapsed = !this.collapsed
  }

  onDrawerChange(show: any) {
    this.collapsed = show
  }

  onMenuSelect() {
    this.toggleCollapse()
  }

  onSettingDrawerChange(val: any) {
    this.showSetting = val
  }

  @Watch('en')
  watchEn() {
    this.init()
  }
  // beforeCreate() {
  //   const router = (this.$router as any).options.routes.find((item: any) => item.path === '/').children
  //   // .filter((it: any) => {
  //   //   return !(it.meta.show && it.meta.show)
  //   // })

  //   menuData = formatroute(router)
  // }
}
